import { PARTICIPACAO_LABEL, PassoParticipacao } from "../types";

/**
 * Seletor da escada de participação psicomotora (componente central do Gingado).
 * 10 passos (0–9). Tocar um passo seleciona — e todos abaixo "enchem" em verde
 * suave, comunicando progresso (não nota). Reaproveita as classes .escada do app.
 */
const PASSOS = Object.values(PassoParticipacao).filter(
  (v): v is PassoParticipacao => typeof v === "number",
);

export function ParticipacaoSelector({
  valor,
  onChange,
}: {
  valor: PassoParticipacao | null;
  onChange: (p: PassoParticipacao) => void;
}) {
  return (
    <div className="escada" role="radiogroup" aria-label="passo na escada de participação">
      {PASSOS.map((p) => {
        const preenchido = valor !== null && p <= valor;
        const atual = valor === p;
        return (
          <button
            key={p}
            type="button"
            role="radio"
            aria-checked={atual}
            className={`escada-passo${preenchido ? " preenchido" : ""}${atual ? " atual" : ""}`}
            onClick={() => onChange(p)}
          >
            <span className="num" aria-hidden>
              {p}
            </span>
            <span>{PARTICIPACAO_LABEL[p]}</span>
          </button>
        );
      })}
    </div>
  );
}
